import { FC, useCallback } from 'react'
import { InlineButton } from 'react-common'
import { useLocation } from 'react-router-dom'
import cn from 'classnames'
import { ActivityType } from '@/api/models/activity'
import { ObjectiveRecord } from '@/api/models/objectiveRecord'
import { useCourseNavigate } from '@/hooks/useCourseNavigate'
import { useEventLogger } from '@/hooks/useEventLogger'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { setLastPageURL } from '@/store/slices/layoutSlice'
import styles from './CourseResults.module.scss'

type Props = {
  result: ObjectiveRecord
}
export const ArrowResultButton: FC<Props> = ({ result }) => {
  const { navigateToActivityWorkflowView, navigateToContent } = useCourseNavigate()
  const { pathname, search } = useLocation()
  const dispatch = useAppDispatch()
  const { logEvent } = useEventLogger()

  const aggregate = useAppSelector((state) => state.aggregate.current)

  const handleClick = useCallback(() => {
    dispatch(setLastPageURL(pathname + search))

    const isLti = aggregate?.objective?.activity?.type === ActivityType.lti

    if (isLti) {
      navigateToActivityWorkflowView(result.objective.id, result.activityRecord.activityWorkflowId!)
    } else {
      // for the other types, we can go usual course content, because it has no workflow related stuff
      navigateToContent(result.objective.id)
    }

    logEvent('course_open_for_review', { objective: result.objective })
  }, [
    dispatch,
    pathname,
    search,
    aggregate?.objective?.activity?.type,
    logEvent,
    result.objective,
    result.activityRecord?.activityWorkflowId,
    navigateToActivityWorkflowView,
    navigateToContent,
  ])

  // it may mean edx migrated course
  if (!result.objectiveWorkflowId) {
    return
  }

  if (!result.activityRecord?.activityWorkflowId) {
    return
  }

  return (
    <td className={cn(styles.otherResultsCell, styles.showResultBtnColumn)}>
      <div className={cn(styles.showResultBtn)}>
        <InlineButton
          size="medium"
          data-qa="show-more-button"
          leftIcon="ArrowRightMediumStroke"
          aria-label="Open course for review"
          onClick={handleClick}
        />
      </div>
    </td>
  )
}
